<div id="appcont" theme class="container">
  <div class="row">
    <div id="main_cnt" class="col-lg-12 col-md-12 col-sm-12">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 col-sm-12">
      &nbsp;
    </div>
  </div>
</div>